import { render, staticRenderFns } from "./knowledgeDetails.vue?vue&type=template&id=fc433b18&scoped=true"
import script from "./knowledgeDetails.vue?vue&type=script&lang=js"
export * from "./knowledgeDetails.vue?vue&type=script&lang=js"
import style0 from "./knowledgeDetails.vue?vue&type=style&index=0&id=fc433b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc433b18",
  null
  
)

export default component.exports